import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5fef47bf")

_pushScopeId("data-v-5fef47bf")
const _hoisted_1 = { class: "main-content" }
const _hoisted_2 = {
  key: 3,
  class: "social"
}
const _hoisted_3 = {
  key: 8,
  class: "button-wrap"
}
const _hoisted_4 = { class: "download-btn" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_top_bar = _resolveComponent("top-bar")!
  const _component_nav_bar = _resolveComponent("nav-bar")!
  const _component_social_btn = _resolveComponent("social-btn")!
  const _component_close_btn = _resolveComponent("close-btn")!
  const _component_back_btn = _resolveComponent("back-btn")!
  const _component_intro_battle_popup = _resolveComponent("intro-battle-popup")!
  const _component_orientation = _resolveComponent("orientation")!
  const _component_Footer = _resolveComponent("Footer")!
  const _directive_gameClass = _resolveDirective("gameClass")!

  return _withDirectives((_openBlock(), _createBlock("main", {
    class: ["main", _ctx.$nowLang]
  }, [
    _createVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default", _ctx.$attrs, undefined, true),
      (_ctx.isShowTopBar)
        ? (_openBlock(), _createBlock(_component_top_bar, {
            key: 0,
            comKey: "topBar"
          }))
        : _createCommentVNode("", true),
      (_ctx.isShowNavBar)
        ? (_openBlock(), _createBlock(_component_nav_bar, {
            key: 1,
            comKey: "navBar"
          }))
        : _createCommentVNode("", true),
      (_ctx.showNavIntroBtn)
        ? (_openBlock(), _createBlock("a", {
            key: 2,
            href: "javascript:;",
            class: "extra",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.extraHandle && _ctx.extraHandle(...args)))
          }))
        : _createCommentVNode("", true),
      (_ctx.showSocialBtn)
        ? (_openBlock(), _createBlock("div", _hoisted_2, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.socialBtnList, (item) => {
              return (_openBlock(), _createBlock(_component_social_btn, {
                key: item,
                type: item.type,
                link: item.link,
                openWay: item.openWay,
                bg: item.bg
              }, null, 8, ["type", "link", "openWay", "bg"]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (
          !_ctx.showSdkTopBar &&
            _ctx.showPageBar &&
            _ctx.showCloseBtn &&
            _ctx.showCloseBtnManual &&
            _ctx.isRunInsdk
        )
        ? (_openBlock(), _createBlock(_component_close_btn, {
            key: 4,
            class: "close-btn"
          }))
        : _createCommentVNode("", true),
      (!_ctx.showSdkTopBar && _ctx.showPageBar && _ctx.showBackBtn)
        ? (_openBlock(), _createBlock(_component_back_btn, {
            key: 5,
            class: "back-btn",
            comKey: "backBtn"
          }))
        : _createCommentVNode("", true),
      (_ctx.showNavIntroBtn)
        ? (_openBlock(), _createBlock(_component_intro_battle_popup, {
            key: 6,
            visible: _ctx.showExtraPopup,
            "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (_ctx.showExtraPopup = $event)),
            onClose: _ctx.closeExtraPopup
          }, null, 8, ["visible", "onClose"]))
        : _createCommentVNode("", true),
      (_ctx.showOrientation)
        ? (_openBlock(), _createBlock(_component_orientation, {
            key: 7,
            directionVertical: true
          }))
        : _createCommentVNode("", true),
      (_ctx.$isXddq || _ctx.$isXddqJp)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _createVNode("a", {
              class: "service",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.openService && _ctx.openService(...args))),
              href: "javascript:;"
            }, _toDisplayString(_ctx.$t('serviceContact')), 1),
            _createVNode("div", _hoisted_4, [
              _createVNode("a", {
                class: "btn applestore",
                href: _ctx.$isXddq ? 'https://apps.apple.com/tw/app/%E5%B0%8F%E5%A6%96%E5%95%8F%E9%81%93/id6450647359':'https://apps.apple.com/jp/app/id6451475891',
                target: "_blank"
              }, null, 8, ["href"]),
              _createVNode("a", {
                class: "btn googleplay",
                href: _ctx.$isXddq ? 'https://play.google.com/store/apps/details?id=com.global.xddq' : 'https://play.google.com/store/apps/details?id=com.global.xddqjp',
                target: "_blank"
              }, null, 8, ["href"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (+_ctx.gameId() === 337)
      ? (_openBlock(), _createBlock(_component_Footer, { key: 0 }))
      : _createCommentVNode("", true)
  ], 2)), [
    [_directive_gameClass]
  ])
})